import {
  Component,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'ew-table-card-column',
  templateUrl: './table-card-column.component.html',
  styleUrls: ['./table-card-column.component.scss'],
})
export class TableCardColumnComponent implements OnInit {
  @ViewChild(TemplateRef) content!: TemplateRef<any>;

  constructor() {}

  ngOnInit(): void {}
}
